import { Component, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { FundingsourcestoreService } from '../../services/store/fundingsource-store/fundingsource-store.service';
import { SpaceTypeStoreService } from '../../services/store/spacetype-store/spacetype-store.service';
import { TripStoreService } from '../../services/store/trip-store/trip-store.service';
import { FleetStoreService } from '../../services/store/fleet-store/fleet-store.service';
import { formatDate, statusMap } from '../../utils/date-util';
import { statuses } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-route-listing',
  templateUrl: './route-listing.component.html',
  styleUrls: ['./route-listing.component.css']
})
export class RouteListingComponent implements OnInit {
  dataList = [];
  skip = 0;
  user;
  todayDate = [];
  timeZone;
  formatDate = formatDate;
  statusMap = statusMap;

  corporates: any = {};
  spaceTypes: any = {};
  trips = [];
  fleets: any = {};
  assignModalObj;
  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private fundingSourceStore: FundingsourcestoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private tripStore: TripStoreService,
    private fleetStore: FleetStoreService

  ) { }

  ngOnInit() {
    this.getUser()
    this.fundingSourceStore.state$.subscribe((res) => {
      if (res) {
        this.corporates = res;
      }
    }
    );

    this.spaceTypeStore.state$.subscribe((res) => {
      if (res) {
        this.spaceTypes = res;
      }
    }
    );
    this.tripStore.state$.subscribe((res) => {
      if (res) {
        this.trips = res.list;
        this.driverDistance(this.trips);
      }
    }
    );
    this.fleetStore.state$.subscribe((res) => {
      if (res) {
        this.fleets = res;
      }
    }
    );

  }

  timeDifference(start: any, end: any) {
    const startTime = moment(start).tz(this.timeZone);
    const endTime = moment(end).tz(this.timeZone);
    const duration = moment.duration(endTime.diff(startTime));
    const hours = moment.utc(duration.asMilliseconds()).format('H');
    const minutes = moment.utc(duration.asMilliseconds()).format('m');

    const newHour = parseInt(hours);
    return `${newHour > 0 ? newHour +' hr(s) and':'' } ${minutes} min(s)`;
  }


  async driverDistance(trips) {
    for (let trip of trips) {
      const res = await this.assignTripService.getDistance(trip.jobOriginLatitude, trip.jobOriginLongitude, trip.jobDestinationLatitude, trip.jobDestinationLongitude, false)
      if (res) {
        const distance = res.distance;
        const duration = moment.duration(res.duration, 'minutes');
        const hours = moment.utc(duration.asMilliseconds()).format('H');
        const minutes = moment.utc(duration.asMilliseconds()).format('m');
        const newHour = parseInt(hours);
        trip.driveDistance = `${distance.toFixed(2)} mi / ${newHour > 0 ? newHour +' hr(s) and':'' } ${minutes} min(s)`;

      }
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day"),
            moment.tz(this.timeZone).endOf("day")
          ];
        }
      });
  }
  openNoteModal(trip) {
    this.assignModalObj = trip;
  }

  ngOnDestroy(): void {

  }

}
